<div class="facial-recognition-entry-div text-center p-3">
  <div class="facial-recognition-entry-img-div mx-auto mb-3 border rounded-4 d-flex align-items-center justify-content-center">
    <img
      *ngIf="facialRecognitionImage"
      [src]="facialRecognitionImage"
      alt="facialRecognitionImage"
      class="facial-recognition-entry-img rounded"
    />
    <div *ngIf="!facialRecognitionImage" class="icon material-icons facial-recognition-entry-placeholder text-info">
      account_circle
    </div>
  </div>
  <div class="facial-recognition-entry-heading mb-2 font-size-14 fw-bold">
    {{ 'facial.recognition.entry.heading' | translate }}
  </div>
  <div class="facial-recognition-entry-subheading mb-3 font-size-14">
    <ng-container *ngIf="!facialRecognitionImage">{{ 'facial.recognition.entry.subheading' | translate }}</ng-container>
    <ng-container *ngIf="facialRecognitionImage">{{ 'facial.recognition.entry.submitted.subheading' | translate }}</ng-container>
  </div>
  <button
    class="btn facial-recognition-entry-button font-size-14 fw-bold w-100 rounded-4"
    [ngClass]="facialRecognitionImage ? 'btn-outline-black' : 'btn-black'"
    (click)="goToFacialRecognition()"
  >
    <ng-container *ngIf="!facialRecognitionImage">{{ 'facial.recognition.entry.button.text' | translate }}</ng-container>
    <ng-container *ngIf="facialRecognitionImage">{{ 'facial.recognition.entry.submitted.button.text' | translate }}</ng-container>
  </button>
</div>
